<!-- Shared chart base: grid, coast and depth contours (viewBox 600x600). -->
<ng-template #base>
  <svg:g>
  <defs>
    <pattern id="chart-grid" width="50" height="50" patternUnits="userSpaceOnUse">
      <path class="grid-line" d="M50 0H0V50" />
    </pattern>
    <path id="chart-land" d="M0 0H250C225 55 245 105 195 158S120 225 150 292S62 372 0 412Z" />
  </defs>
  <rect class="sea" width="600" height="600" rx="28" />
  <rect width="600" height="600" rx="28" fill="url(#chart-grid)" />
  <use href="#chart-land" class="contour" transform="translate(120 20)" />
  <use href="#chart-land" class="contour" transform="translate(70 10)" />
  <use href="#chart-land" class="contour" transform="translate(28 4)" />
  <use href="#chart-land" class="land" />
  </svg:g>
</ng-template>

<div class="stage" [ngClass]="'s' + scene" [class.paused]="!active">
  <div class="glow"></div>

  <div class="plane">
    <svg class="chart" viewBox="0 0 600 600" aria-hidden="true">
      <ng-container *ngTemplateOutlet="base"></ng-container>

      <ng-container [ngSwitch]="scene">
        <!-- Discover: one outing, replayed -->
        <g *ngSwitchCase="0">
          <path id="trip-track" class="track" pathLength="1" d="M170 292C250 250 320 190 395 245S520 360 455 465S300 530 250 430S205 345 170 292" />
          <g>
            <g transform="rotate(90)"><image href="assets/vessel_skins/vessel_sportfish.svg" x="-13" y="-29" width="26" height="58" /></g>
            <animateMotion dur="12s" repeatCount="indefinite" rotate="auto" keyPoints="0;1;1" keyTimes="0;0.75;1" calcMode="linear">
              <mpath href="#trip-track" />
            </animateMotion>
          </g>
        </g>

        <!-- Connect: your boat plus the crew, linked -->
        <g *ngSwitchCase="1">
          <g class="links">
            <path d="M330 330L455 205" /><path d="M330 330L480 440" /><path d="M330 330L255 485" />
          </g>
          <circle class="own-disc" cx="330" cy="330" r="38" />
          <circle class="ripple" cx="330" cy="330" r="38" />
          <circle class="ripple r2" cx="330" cy="330" r="38" />
          <g transform="rotate(35 330 330)"><image href="assets/vessel_skins/vessel_sportfish.svg" x="316" y="300" width="28" height="60" /></g>
          <g transform="rotate(-20 455 205)"><image href="assets/vessel_skins/vessel_center_console.svg" x="443" y="178" width="24" height="54" /></g>
          <g transform="rotate(70 480 440)"><image href="assets/vessel_skins/vessel_downeast.svg" x="467" y="412" width="26" height="56" /></g>
          <g transform="rotate(10 255 485)"><image href="assets/vessel_skins/vessel_sportfish.svg" x="242" y="456" width="26" height="58" /></g>
        </g>

      </ng-container>
    </svg>

    <!-- Enhance: the radar sits partly upright (tilted less than the chart) so it reads towards the viewer. -->
    <div class="radar-tilt" *ngIf="scene === 2"><div class="radar"></div></div>
    <i class="hot" *ngIf="scene === 2" style="left: 62%; top: 36%"></i>
    <i class="hot" *ngIf="scene === 2" style="left: 36%; top: 68%; animation-delay: -2s"></i>
    <i class="hot" *ngIf="scene === 2" style="left: 72%; top: 70%; animation-delay: -4s"></i>

    <!-- Waypoint pins stand upright on the tilted chart -->
    <ng-container [ngSwitch]="scene">
      <ng-container *ngSwitchCase="0">
        <span class="pin" style="left: 28%; top: 48.5%"><img src="assets/waypoint_icons/pins/home.png" alt="" style="--d: 0s" /></span>
        <span class="pin" style="left: 65.8%; top: 40.8%"><img src="assets/waypoint_icons/caught_yellowfin.png" alt="" style="--d: 3.4s" /></span>
        <span class="pin" style="left: 81.7%; top: 55%"><img src="assets/waypoint_icons/pins/temp.png" alt="" style="--d: 5.6s" /></span>
        <span class="pin" style="left: 55%; top: 82.5%"><img src="assets/waypoint_icons/pins/mark.png" alt="" style="--d: 7.6s" /></span>
      </ng-container>
      <ng-container *ngSwitchCase="1">
        <span class="pin" style="left: 66%; top: 44%"><img src="assets/waypoint_icons/pins/mark.png" alt="" style="--d: 1s" /></span>
        <span class="pin" style="left: 42%; top: 76%"><img src="assets/waypoint_icons/pins/wreck.png" alt="" style="--d: 4s" /></span>
      </ng-container>
      <ng-container *ngSwitchCase="2">
        <span class="pin" style="left: 62%; top: 36%"><img src="assets/waypoint_icons/pins/mark.png" alt="" style="--d: 1.5s" /></span>
        <span class="pin" style="left: 36%; top: 68%"><img src="assets/waypoint_icons/pins/temp.png" alt="" style="--d: 3.5s" /></span>
        <span class="pin" style="left: 72%; top: 70%"><img src="assets/waypoint_icons/pins/bait.png" alt="" style="--d: 5.5s" /></span>
      </ng-container>
    </ng-container>
  </div>

  <ng-container [ngSwitch]="scene">
    <!-- ───── Discover: context, conditions, insight → a narrative ───── -->
    <ng-container *ngSwitchCase="0">
      <div class="card" style="left: 5%; top: 7%">
        <div class="eyebrow">Trip replay</div>
        <div class="title">Offshore run · 30 Fathom Line</div>
        <div class="stats">
          <div><b>42</b><span>nm</span></div>
          <div><b>6h 12m</b><span>underway</span></div>
          <div><b>9.4</b><span>kn avg</span></div>
        </div>
      </div>
      <div class="card" style="right: 5%; top: 17%; animation-delay: -2s">
        <div class="eyebrow">Conditions</div>
        <ul class="rows">
          <li><i class="dot teal"></i>Wind <b>12 kt NE</b></li>
          <li><i class="dot amber"></i>Sea temp <b>72°F</b></li>
          <li><i class="dot blue"></i>Swell <b>3 ft · 8 s</b></li>
          <li><i class="dot teal"></i>Tide <b>Rising ↑</b></li>
        </ul>
      </div>
      <div class="card" style="right: 8%; top: 54%; animation-delay: -4s">
        <div class="eyebrow">Moments</div>
        <ul class="rows timeline">
          <li><time>06:10</time>Left the dock</li>
          <li><time>08:45</time>Temp break found</li>
          <li><time>10:20</time>Yellowfin on the deck</li>
        </ul>
      </div>
    </ng-container>

    <!-- ───── Connect: friends, crews, trusted networks, on your terms ───── -->
    <ng-container *ngSwitchCase="1">
      <div class="card chat" style="left: 5%; top: 7%">
        <div class="head">
          <span class="avatars"><i class="av a1">M</i><i class="av a2">J</i><i class="av a3">R</i></span>
          <span><div class="title">Dockmates</div><div class="muted">4 online</div></span>
        </div>
        <p class="msg in" style="--d: 0s"><b>Mike</b>Temp break just north of the canyon.</p>
        <p class="msg out" style="--d: 2.2s">On my way. Sharing my trip.</p>
        <p class="msg share" style="--d: 4.2s"><span class="mini"></span><span><b>Shared trip</b><em>Canyon run · 38 nm</em></span></p>
      </div>
      <div class="card" style="right: 5%; top: 18%; animation-delay: -2s">
        <div class="eyebrow">Who can view</div>
        <div class="chips">
          <span class="chip">Private</span>
          <span class="chip on">Pier Circle</span>
          <span class="chip">The Water</span>
        </div>
        <div class="muted" style="margin-top: 0.5em">Dockmates and Fleets only</div>
      </div>
      <div class="card" style="right: 9%; top: 52%; animation-delay: -4s">
        <div class="head">
          <span class="avatars"><i class="av a2">J</i><i class="av a3">R</i><i class="av a1">+1</i></span>
          <span><div class="title">Ride-along</div><div class="muted">3 aboard · live</div></span>
        </div>
      </div>
    </ng-container>

    <!-- ───── Enhance: patterns surfaced, the busywork done for you ───── -->
    <ng-container *ngSwitchCase="2">
      <div class="card" style="left: 5%; top: 7%">
        <div class="eyebrow">Tide</div>
        <div class="title">Rising · high at 7:10 AM</div>
        <div class="bar"><i></i></div>
        <div class="muted">Wind forecast and surface currents on</div>
      </div>
      <div class="card" style="right: 5%; top: 17%; animation-delay: -2s">
        <div class="eyebrow">Temp Break</div>
        <div class="title">2.1 nm NE <span class="up">+3.1°F</span></div>
        <div class="muted">Marked by your dockmates</div>
      </div>
      <div class="card" style="right: 8%; top: 54%; animation-delay: -4s">
        <div class="eyebrow">Recorded for you</div>
        <ul class="rows checks">
          <li style="--d: 0s"><i class="tick"></i>Trip track</li>
          <li style="--d: 1.4s"><i class="tick"></i>Observations</li>
          <li style="--d: 2.8s"><i class="tick"></i>Waypoints</li>
          <li style="--d: 4.2s"><i class="tick"></i>Wind and tide</li>
        </ul>
      </div>
    </ng-container>
  </ng-container>
</div>
